module.exports = __webpack_public_path__ + "static/media/contact-liftup-2.155b8bd6.jpg";